import { getSignature } from "@/http/url.js"
/**
 * @description 接受四个参数
 * @export
 * @param {*} { title, desc, link, imgUrl }
 */
export default function ({ title, desc, link, imgUrl }) {
  let req = { url: window.location.href.split("#")[0] };
  getSignature(req).then(({ data, status }) => {
    if (status !== 200) return
    try {
      let item = JSON.parse(data);
      wx.config({
        debug: false,
        appId: item.appid, // 必填，公众号的唯一标识
        timestamp: item.timestamp, // 必填，生成签名的时间戳s
        nonceStr: item.nonceStr, // 必填，生成签名的随机串
        signature: item.signature,// 必填，签名
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData',]
      });
      let shareInfo = {
        title,
        desc,
        link,
        imgUrl,
        success: function () {
          console.info("分享设置成功")
        },
        cancel: function () {
          console.log("取消分享");
        }
      };
      
        wx.updateAppMessageShareData(shareInfo);
        wx.updateTimelineShareData(shareInfo);
      
    } catch (e) {
    }
  })
}